<div class="flex flex-col w-full h-full">
  <app-breadcrumb class="mb-2" [items]="breadcrumdItems" />

  <h1 class="mb-8 text-light-300 text-3xl font-medium">
    Deposit money to your Seedio's wallet
  </h1>

  <p-card
    class="w-full h-full"
    [style]="{
        overflow: 'hidden',
        height: '100%',
      }"
  >
    <p-stepper [value]="1">
      <!-- STEP 1 -->
      <p-step-item [value]="1">
        <p-step>Deposit method</p-step>
        <p-step-panel>
          <ng-template #content let-activateCallback="activateCallback">
            <div class="flex flex-col h-60 overflow-auto">
              <div
                class="flex-auto flex flex-col gap-5 justify-start items-start font-medium py-2"
              >
                <p class="text-lg text-light-200">
                  Choose one of your linked bank accounts below, or add a new
                  one to proceed with your deposit.
                </p>

                <app-bank-accounts-list class="w-full" [isStandalone]="false" />
              </div>
            </div>

            <div class="pt-3 pb-6">
              <p-button label="Next" (onClick)="activateCallback(2)" />
            </div>
          </ng-template>
        </p-step-panel>
      </p-step-item>

      <!-- STEP 2 -->
      <p-step-item [value]="2">
        <p-step>Initiate transfer at your bank</p-step>
        <p-step-panel>
          <ng-template #content let-activateCallback="activateCallback">
            <div class="flex flex-col h-[460px]">
              <div
                class="flex-auto flex flex-col gap-5 justify-start items-start font-medium py-2"
              >
                <p class="text-lg text-light-200">
                  Log in to your bank and make a transfer to Seedio using the
                  details below.
                </p>

                <p-divider styleClass="m-0! h-1!" />

                <div class="grid grid-cols-2 gap-x-2 gap-y-8 w-full">
                  <!-- Beneficiary Name -->
                  <div class="flex flex-col gap-1">
                    <span class="text-base text-light-300"
                      >Beneficiary Name</span
                    >
                  </div>
                  <div class="flex flex-row gap-6 items-center justify-start">
                    <span class="font-semibold text-base text-light-200"
                      >Seedio Ltd.</span
                    >
                    <svg-icon
                      copyClipboard="Seedio Ltd."
                      src="assets/icons/copy.svg"
                      svgClass="w-5 h-5 icon cursor-pointer text-light-100"
                    />
                  </div>

                  <!-- Beneficiary Address -->
                  <div class="flex flex-col gap-1">
                    <span class="text-base text-light-300"
                      >Beneficiary Address</span
                    >
                  </div>
                  <div class="flex flex-row gap-6 items-center justify-start">
                    <p class="font-semibold text-base text-light-200">
                      Chanioporta 8, 15124,<br />
                      Heraklion, Crete, Greece
                    </p>
                  </div>

                  <!-- IBAN -->
                  <div class="flex flex-col gap-1">
                    <span class="text-base text-light-300">IBAN</span>
                  </div>
                  <div class="flex flex-row gap-6 items-center justify-start">
                    <span class="font-semibold text-base text-light-200"
                      >GR12346351413461341241</span
                    >
                    <svg-icon
                      copyClipboard="GR12346351413461341241"
                      src="assets/icons/copy.svg"
                      svgClass="w-5 h-5 icon cursor-pointer text-light-100"
                    />
                  </div>

                  <!-- SWIFT/BIC -->
                  <div class="flex flex-col gap-1">
                    <span class="text-base text-light-300">SWIFT/BIC</span>
                  </div>
                  <div class="flex flex-row gap-6 items-center justify-start">
                    <span class="font-semibold text-base text-light-200"
                      >PGRXXXXXX</span
                    >
                    <svg-icon
                      copyClipboard="PGRXXXXXX"
                      src="assets/icons/copy.svg"
                      svgClass="w-5 h-5 icon cursor-pointer text-light-100"
                    />
                  </div>

                  <!-- Bank Name -->
                  <div class="flex flex-col gap-1">
                    <span class="text-base text-light-300">Bank Name</span>
                  </div>
                  <div class="flex flex-row gap-6 items-center justify-start">
                    <span class="font-semibold text-base text-light-200">
                      Piraeus Bank, Heraklion, Greece
                    </span>
                    <svg-icon
                      copyClipboard="Piraeus Bank, Heraklion, Greece"
                      src="assets/icons/copy.svg"
                      svgClass="w-5 h-5 icon cursor-pointer text-light-100"
                    />
                  </div>
                </div>

                <p-divider styleClass="m-0! h-1!" />

                <p class="font-normal text-base text-red-100">
                  Transfers must be made from bank accounts you have already
                  linked in Seedio. Transfers from unlinked accounts will be
                  rejected and returned, and any bank charges will be at your
                  expense.
                </p>
              </div>
            </div>

            <div class="flex pt-3 pb-6 gap-2">
              <p-button
                label="Back"
                severity="primary"
                variant="outlined"
                (onClick)="activateCallback(1)"
              />
              <p-button label="Next" (onClick)="activateCallback(3)" />
            </div>
          </ng-template>
        </p-step-panel>
      </p-step-item>

      <!-- STEP 3 -->
      <p-step-item [value]="3">
        <p-step>Receive funds in your Seedio account</p-step>
        <p-step-panel>
          <ng-template #content let-activateCallback="activateCallback">
            <div class="flex flex-col h-52">
              <div
                class="flex-auto flex flex-col gap-5 justify-start items-start font-medium py-2"
              >
                <p class="text-lg text-light-200">
                  Once you’ve completed the transfer, your funds
                  <b>will be received</b> in your Seedio wallet
                  <b>within 1–3 business days</b>, depending on your bank’s
                  processing times and cut-offs.
                </p>

                <p-divider styleClass="m-0! h-1!" />

                <div>
                  <p class="font-semibold text-base text-light-200 mb-2">
                    About bank transfers:
                  </p>

                  <p class="font-semibold text-base text-light-200">
                    <b>Fees:</b> You are responsible for any fees charged by
                    your bank. Seedio does not charge additional transfer fees.
                  </p>
                </div>
              </div>
            </div>

            <div class="p-3 pb-6">
              <p-button
                label="Back"
                severity="primary"
                variant="outlined"
                (onClick)="activateCallback(2)"
              />
            </div>
          </ng-template>
        </p-step-panel>
      </p-step-item>
    </p-stepper>
  </p-card>
</div>
